export default __webpack_public_path__ + "static/media/rzz.17533306.jpg";